import { Injectable } from '@angular/core';
import { ImportGiftRow } from 'app/models/import-gift.model';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class ImportGiftRowsService {


  baseUrl = HttpClientService.BASE_MS_PROMO;
  cachedImportGiftRows: Observable<ImportGiftRow>;
  importHeadId: number;

  constructor(private http: HttpClientService) { }

  /**
      * Tramite metodo GET, restituisce la lista delle importazioni
      * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
    */
   list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<ImportGiftRow>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/catalogImportGift/detail?import_gift_head_id=${this.importHeadId}` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

     /**
     * Tramite metodo GET carico i campi del dto di ImportGiftDetail in un Observable
     * @returns il dto Import Gift Detail
     */
      getImportFields() {
        if (!this.cachedImportGiftRows) {
          this.cachedImportGiftRows= this.http.get(`${this.baseUrl}/schema/CatalogGiftImportDetailDto`).pipe(
            publishReplay(1), // this tells Rx to cache the latest emitted
            refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
          )
        }
        return this.cachedImportGiftRows;
      }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/import-gift-rows.service.ts